<div *ngIf="isLoading | async">
    <p-dialog header="" [(visible)]="showModal" [closable]="false" [modal]="true" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
        <div class="text-center">
            <div class="font-loading mb-3">Espere...</div>
            <img src="./assets/img/loading-icon.gif" width="60" alt="Loader image">
        </div>
    </p-dialog>
</div>